// extracted by mini-css-extract-plugin
export var container = "_c0-0";
export var containerTopRight = "_c0-1";